export const DEFAULT_ENRICHMENTS_LIMIT = 1000;
export const ENRICHMENT_RULE_UID_LABEL_PREFIX = 'enrichment-rule.uid';
export const GLOBAL_ENRICHMENT_SCOPE_LABEL_SELECTOR = 'enrichment-scope=global';

/** URL search param keys for enrichment list filters (rule page and settings page). */
export const ENRICHMENT_FILTER_SCOPE_PARAM = 'enrichment_scope';
export const ENRICHMENT_FILTER_TYPE_PARAM = 'enrichment_type';
